import { _ep0, _mw0, command } from "../commandBuilder";
import { CreateRegistration$ } from "../schemas/schemas_0";
export class CreateRegistrationCommand extends command(_ep0, _mw0, "CreateRegistration", CreateRegistration$) {
}
